export default (siteName) => [
    {
        path: 'vendor',
        name: 'vendor',
        component: () => import('../../components/dashboard/Vendor/VendorPage.vue'),
        meta: {
            title: `客戶${siteName}`,
            activeMenu: 'project',
        },
    },
    {
        path: 'vendor/add',
        name: 'vendor-add',
        component: () => import('../../components/dashboard/Vendor/VendorEditPage.vue'),
        meta: {
            title: `新增客戶${siteName}`,
            activeMenu: 'project',
            activeSubMenu: 'vendor',
        },
    },
    {
        path: 'vendor/:sno',
        name: 'vendor-detail',
        component: () => import('../../components/dashboard/Vendor/VendorPage.vue'),
        meta: {
            title: `客戶細節${siteName}`,
            activeMenu: 'project',
            activeSubMenu: 'vendor',
        },
    },
    {
        path: 'vendor/:sno/edit/',
        name: 'vendor-edit',
        component: () => import('../../components/dashboard/Vendor/VendorEditPage.vue'),
        meta: {
            title: `編輯客戶${siteName}`,
            activeMenu: 'project',
            activeSubMenu: 'vendor',
        },
    },
];
